// React polyfill for production builds to ensure forwardRef is available
import React from 'react';

// Ensure React and its exports are available globally
if (typeof window !== 'undefined') {
  (window as any).React = React;
  // Explicitly expose forwardRef
  (window as any).forwardRef = React.forwardRef;
}

export default React;